// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"82":"build/auth/css/admin-login","492":"build/auth/css/login"}[chunkId] + ".css";
};